import { useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { message } from 'antd';
import { ExportOutlined, DeleteOutlined, LayoutOutlined, AppstoreOutlined } from '@ant-design/icons';

import { genericGETDatabaseCall, genericDELETEDatabaseCall } from '../helperFunctions.jsx';
import { PageHead } from '../FinancialBuilder/fbUI.jsx';
import '../FinancialBuilder/financial-builder.css';
import './Dashboard.css';

async function getAllDashboardEntitiesFromServer() {
  return genericGETDatabaseCall('/api/psbb/getDashboardEntities', 'all dashboard entities');
}

async function deleteDashboardEntityFromServer(entityId) {
  return genericDELETEDatabaseCall('/api/psbb/deleteDashboardEntity', { entityId }, 'dashboard entity');
}

export function Dashboard() {
  const [allEntities, setAllEntities] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  const getAllDashboardEntities = useCallback(async () => {
    messageApi.loading("Loading all Dashboard entities...");
    try {
      const data = await getAllDashboardEntitiesFromServer();
      messageApi.destroy();
      messageApi.success("All Dashboard entities loaded successfully");
      setAllEntities(data);
    } catch (error) {
      messageApi.destroy();
      messageApi.error("Failed to load all dashboard entities");
      console.error(error);
    }
  }, [messageApi]);

  const deleteDashboardEntity = async (entityId) => {
    messageApi.loading("Deleting Dashboard entity..");
    try {
      await deleteDashboardEntityFromServer(entityId);
      messageApi.destroy();
      messageApi.success("Dashboard entity deleted successfully");
      setAllEntities(allEntities.filter((entity) => entity.shared_link_uuid !== entityId));
    } catch (error) {
      messageApi.destroy();
      messageApi.error("Failed to delete dashboard entity");
      console.error(error);
    }
  };

  const openDashboard = (uuid) => navigate('/renderTemplate?templateId=' + uuid);

  useEffect(() => {
    getAllDashboardEntities();
  }, [getAllDashboardEntities]);

  return (
    <>
      {contextHolder}
      <div className="pn-dash">
        <PageHead eyebrow="Workspace" title="Dashboards"
          sub={<>Your exported dashboards. Open one to view or share it, or remove the ones you no longer need.</>} />

        {allEntities.length === 0 ? (
          <div className="pn-dash-empty">
            <div className="ic"><AppstoreOutlined /></div>
            <div className="t">No dashboards yet</div>
            <div>Export a dashboard from the Template Render screen and it will show up here.</div>
          </div>
        ) : (
          <div className="pn-dash-list">
            {allEntities.map((entity) => (
              <div key={entity.shared_link_uuid} className="pn-card pn-dash-card">
                <div className="pn-card-top">
                  <div>
                    <div className="pn-card-name">{entity.name || 'Untitled dashboard'}</div>
                    <div className="pn-card-desc">{entity.entity_name}</div>
                  </div>
                  <span className="pn-badge sub"><LayoutOutlined /> Dashboard</span>
                </div>

                <div className="pn-dash-meta">
                  <div className="row"><span className="k">Entity</span><span className="v">{entity.entity_name || '—'}</span></div>
                  <div className="row"><span className="k">Created</span><span className="v">{entity.created_at ? new Date(entity.created_at).toDateString() : '—'}</span></div>
                </div>

                <div className="pn-dash-actions">
                  <button type="button" className="pn-btn pn-btn-danger" onClick={() => deleteDashboardEntity(entity.shared_link_uuid)}>
                    <DeleteOutlined /> Delete
                  </button>
                  <button type="button" className="pn-btn pn-btn-accent" onClick={() => openDashboard(entity.shared_link_uuid)}>
                    Open <ExportOutlined />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default Dashboard;
